import { render, staticRenderFns } from "./history-upload.vue?vue&type=template&id=725c3c72&"
import script from "./history-upload.vue?vue&type=script&lang=js&"
export * from "./history-upload.vue?vue&type=script&lang=js&"
import style0 from "./history-upload.vue?vue&type=style&index=0&id=725c3c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports